import { Box } from '@mui/material';

const RowWrap = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}): React.ReactElement | (React.ReactElement | false)[] | false => {
  return (
    <Box
      width='80%'
      display='flex'
      flexGrow={1}
      flexDirection='row'
      flexWrap='wrap'
      justifyContent='space-between'
      gap={'20px'}
    >
      {children}
    </Box>
  );
};

export default RowWrap;
